import { useState } from "react";
import { FileText, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { apiError, downloadFile } from "@/lib/api";

/** The plain-text note a unit's IT team needs to post compliance to CDTP by itself. */
export const ApiGuideButton = ({ testId = "api-guide-download", className = "" }) => {
  const [busy, setBusy] = useState(false);
  const take = async () => {
    setBusy(true);
    try {
      await downloadFile(
        "/compliance/api-guide",
        { base: process.env.REACT_APP_BACKEND_URL },
        "CDTP Compliance API Guide.txt",
      );
      toast.success("API guide downloaded — share it with the unit's IT team.");
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <button
      type="button"
      data-testid={testId}
      disabled={busy}
      onClick={take}
      className={`inline-flex items-center gap-2 border border-primary px-3 py-2 font-display text-[10px] font-bold uppercase tracking-widest text-primary transition-colors duration-200 hover:bg-primary hover:text-primary-foreground disabled:opacity-50 ${className}`}
    >
      {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <FileText className="h-3.5 w-3.5" />}
      Download the API guide (.txt)
    </button>
  );
};
